import {CircularProgress, Stack, useMediaQuery} from "@mui/material";
import EmptyListText from "components/EmptyListText";
import MaterialItem from "pages/Material/list/components/MaterialItem";
import Pagination from "pages/Material/list/components/Pagination";
import React from "react";
import {useOutletContext} from "react-router-dom";
import {MaterialContextProps} from "pages/Material/types";
import SearchInput from "components/SearchInput";
import MaterialFilterButton from "pages/Material/list/components/MaterialFilterButton";

const MaterialList = () => {
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('xl'))

  const {materialList, loadingMaterials, searchInput, setSearchInput} = useOutletContext<MaterialContextProps>();

  return (
    <Stack spacing={5}>
      <Stack direction={'row'} spacing={4} alignItems={'center'}>

        <SearchInput inputValue={searchInput} setInputValue={setSearchInput}/>
        {!isDesktop && <MaterialFilterButton/>}
      </Stack>
      {
        loadingMaterials ? <CircularProgress/>
          : (
            <Stack>
              {
                !materialList?.data?.length ? <EmptyListText> Пока нет опубликованных материалов</EmptyListText>
                  :
                  materialList?.data.map((material) => (
                    <MaterialItem key={`material-${material.id}`} {...material} />
                  ))}
            </Stack>
          )
      }

      <Pagination totalCount={materialList?.totalCount || 0}/>
    </Stack>
  )
}

export default MaterialList
